/**
 * Canonical Tag Management Utility
 * 
 * Provides helper functions for managing canonical tags in the SPA.
 */

const BASE_URL = 'https://nannygranny.com.au'

/**
 * Updates or creates the canonical link tag in the document head
 * @param {string} url - The canonical URL (can be relative or absolute)
 */
export function updateCanonicalTag(url) {
    // Ensure absolute URL
    const canonicalUrl = url.startsWith('http') ? url : `${BASE_URL}${url}`

    // Find existing canonical tag
    let link = document.querySelector("link[rel='canonical']")

    // Create if doesn't exist
    if (!link) {
        link = document.createElement('link')
        link.setAttribute('rel', 'canonical')
        document.head.appendChild(link)
    }

    // Update href
    link.setAttribute('href', canonicalUrl)
}

/**
 * Removes the canonical tag from the document head
 */
export function removeCanonicalTag() {
    const link = document.querySelector("link[rel='canonical']")
    if (link) {
        link.remove()
    }
}

/**
 * Gets the canonical URL for a route
 * Priority: route.meta.canonical > constructed from path
 * @param {Object} route - Vue Router route object
 * @returns {string} - The canonical URL
 */
export function getCanonicalUrl(route) {
    // If route has explicit canonical in meta, use it
    if (route.meta && route.meta.canonical) {
        return route.meta.canonical
    }

    // For dynamic routes, construct canonical from path
    // Remove trailing slashes and query params
    const cleanPath = route.path.replace(/\/$/, '')

    return `${BASE_URL}${cleanPath}`
}

export default {
    updateCanonicalTag,
    removeCanonicalTag,
    getCanonicalUrl,
    BASE_URL
}



// WEBPACK FOOTER //
// ./src/util/canonical.js